module.exports = __webpack_public_path__ + "img/avatar-45.1e418313.png";